import {
  Query_Persons_OptionsInput,
  usePersonTableQuery
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  fullName: string;
  createdDate: DateTime;
  profileUrl: string;
  phoneNumber: string;
  email: string;
  isActive: boolean;
}

export function useQuery(options: Query_Persons_OptionsInput) {
  const tuple = usePersonTableQuery({
    variables: {
      options
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.persons.map((node) => ({
        id: node?.id ?? '',
        fullName: node?.fullName ?? '',
        createdDate: node?.createdTimestamp ?? DateTime.now(),
        profileUrl: node?.profilePicture?.url ?? '',
        phoneNumber: node?.phoneNumber ?? '',
        email: node?.preferredEmail ?? '',
        isActive: node?.isActive ?? node.memberships.length > 0
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
